import { $http } from '../../../stores/http';
import { deluge } from '@/stores/deluge.js';

export async function deleteTemplate(templateUID) {
  const resp = await $http(
    'DELETE',
    '/v2/delete_template?template_uid=' + templateUID
  );
  return resp;
}

export function getCopyOfTemplate(templateObj) {
  let copy = JSON.parse(JSON.stringify(templateObj));

  if (copy.default_triggers) {
    for (const trigger of copy.default_triggers) {
      const name = trigger.type;
      copy.default_triggers[trigger] = {
        ...deluge.triggers[name],
        ...trigger,
      };
    }
  }
  return copy;
}
